// 处理数据 整数 提取 整数部分 、小数部分
const filterNum = (val, type) => {
  val = toDecimal2(val);
  let arr = [];
  if (val > 0) {
    arr = String(val).split(".");
  } else {
    val = 0.00;
    arr = String(val).split(".");

  }

  if (type == 1) {
    return arr[1];
  } else {
    return arr[0];
  }

}

/* 钱格式化，保留两位小数 */
const toDecimal2 = (x = 0) => {
  let fs = parseFloat(x);
  if (isNaN(fs)) {
    return 0.00;
  }
  if (fs <= 0) {
    return 0.00;
  }
  let f = Math.round(x * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}

const formatDate = (date, fmt) => {
  if (!date || date == null) {
    return '';
  }
  // date = date.replace(/-/g, '/')
  date = new Date(date);
  if (fmt == 0) {
    fmt = "yyyy-MM-dd hh:mm:ss"
  } else if (fmt == 1) {
    fmt = "yyyy-MM-dd"
  } else if (fmt == 2) {
    fmt = "hh:mm:ss"
  } else if (fmt == 3) {
    fmt = "yyyy年MM月dd日 hh时mm分ss秒"
  } else if (fmt == 4) {
    fmt = "yyyy年MM月dd日"
  } else if (fmt == 5) {
    fmt = "hh时mm分ss秒"
  } else if (fmt == 6) {
    fmt = "yyyy年MM月"
  } else if (fmt == 7) {
    fmt = "yyyy"
  } else if (fmt == 8) {
    fmt = "yyyy/MM/dd"
  } else if (fmt == 9) {
    fmt = "hh:mm"
  } else if (fmt == 10) {
    fmt = "MM-dd hh:mm"
  } else if (fmt == 11) {
    fmt = "yyyy.MM.dd hh:mm"
  } else if (fmt == 12) {
    fmt = "MM月dd日"
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};
/* 一位数两位数转换 */
const padLeftZero = (str) => {
  return ('00' + str).substr(str.length);
};

const notAvailable = (data) => {
  if (!data || data == null) {
    return localStorage.getItem('languageType') == 'en' ? 'No Result' : '暂无';
  } else {
    return data;
  }
}

// 格式化日期
const filterDateUnix = timestamp => {
  const _date = new Date(timestamp)
  const y = _date.getFullYear()
  const m = _date.getMonth() + 1
  const d = _date.getDate()
  const h = _date.getHours()
  const mm = _date.getMinutes()
  const s = _date.getSeconds()

  return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + (h < 10 ? '0' + h : h) + ':' + (mm < 10 ? '0' + mm : mm) + ':' + (s < 10 ? '0' + s : s)
}

export {
  filterNum,
  formatDate,
  notAvailable,
  filterDateUnix
}